import { of } from 'rxjs';
var PolicyServiceStub = /** @class */ (function () {
    function PolicyServiceStub() {
    }
    PolicyServiceStub.prototype.getBranchesList = function () {
        return of([]);
    };
    PolicyServiceStub.prototype.setElectronicMarkByPolicyPeriodId = function () {
        return of(null);
    };
    PolicyServiceStub.prototype.getElectronicMarkByPolicyPeriodId = function (policyPeriodId) {
        return of({ electronicDocumentsMark: true });
    };
    PolicyServiceStub.prototype.primaryContactData = function () { };
    PolicyServiceStub.prototype.getPaymentInfo = function (arg1, arg2) { return of({}); };
    PolicyServiceStub.prototype.getSimplePolicyHeader = function (arg) { return of({}); };
    PolicyServiceStub.prototype.getMailingAddress = function (policyNumber) {
        return of({
            mailingAddress: {
                active: true,
                addressLine1: 'Entre rios',
                addressLine2: '',
                addressLine3: '',
                addressType: {
                    code: '',
                    description: ''
                },
                block: '',
                coordinates: '',
                country: {
                    code: 'ar',
                    description: 'Argentina'
                },
                county: '',
                description: '',
                displayText: '',
                policyAddress: '',
                primaryAddress: '',
                publicId: '',
                state: {
                    code: '',
                    description: ''
                },
                streetNumber: '1543',
                postalCode: '2000',
                city: 'Rosario'
            }
        });
    };
    PolicyServiceStub.prototype.getPolicyNumberByJobNumber = function () {
        return '01-01-01-30000000';
    };
    PolicyServiceStub.prototype.deleteDraft = function () {
        return of(null);
    };
    return PolicyServiceStub;
}());
export { PolicyServiceStub };
